import React, { useEffect, useState } from "react";
import axios from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";
export default function AdminCoupons() {
const navigate = useNavigate();
  const [coupons, setCoupons] = useState([]);
  const [form, setForm] = useState({
    code: "",
    discount: "",
    min: "",
    max: "",
  });

  useEffect(() => {
    loadCoupons();
  }, []);

  const loadCoupons = async () => {
    const res = await axios.get("/admin/coupons/");
    setCoupons(res.data);
  };

  const createCoupon = async () => {

    await axios.post("/admin/coupons/create/", {
      code: form.code,
      discount_amount: form.discount,
      min_order_amount: form.min,
      max_uses: form.max,
    });

    alert("Coupon Created ✅");

    setForm({ code: "", discount: "", min: "", max: "" });

    loadCoupons();
  };

  const toggleCoupon = async (id) => {

    await axios.post("/admin/coupons/toggle/", {
      coupon_id: id,
    });

    loadCoupons();
  };

  return (
    <div style={{ padding: 20 }}>
      <button onClick={() => navigate("/admin")} style={styles.backBtn}>
        ← Back
      </button>
      <h2>Coupon Management</h2>

      {/* CREATE FORM */}
      <div style={box}>

        <h3>Create Coupon</h3>

        <input
          placeholder="Code"
          value={form.code}
          onChange={(e)=>setForm({...form,code:e.target.value})}
        />

        <input
          placeholder="Discount"
          value={form.discount}
          onChange={(e)=>setForm({...form,discount:e.target.value})}
        />

        <input
          placeholder="Min Order"
          value={form.min}
          onChange={(e)=>setForm({...form,min:e.target.value})}
        />

        <input
          placeholder="Max Uses"
          value={form.max}
          onChange={(e)=>setForm({...form,max:e.target.value})}
        />

        <button onClick={createCoupon}>
          Create
        </button>

      </div>

      {/* LIST */}
      <h3>All Coupons</h3>

      <table width="100%" border="1" cellPadding="8">

        <thead>
          <tr>
            <th>Code</th>
            <th>Discount</th>
            <th>Used</th>
            <th>Limit</th>
            <th>Active</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>

          {coupons.map(c => (

            <tr key={c.id}>

              <td>{c.code}</td>
              <td>₹{c.discount}</td>
              <td>{c.used}</td>
              <td>{c.max_uses}</td>
              <td>{c.active ? "Yes" : "No"}</td>

              <td>
                <button onClick={()=>toggleCoupon(c.id)}>
                  {c.active ? "Disable" : "Enable"}
                </button>
              </td>

            </tr>

          ))}

        </tbody>

      </table>

    </div>
  );
}

const box = {
  border: "1px solid #ccc",
  padding: 15,
  marginBottom: 20
};
const styles = {
  backBtn: {
    marginBottom: 10,
    padding: "6px 12px",
    background: "#ddd",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
  },};